import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import {CarDefault, CardFigure, CarDefaultBody, CardDesc, CardTitle} from "../Section"

const WarrantyCard = () => {
  return (
    <CarDefault className='card card-default'>
      <CardFigure><StaticImage src="../../images/limited-warranty.png" placeholder="blurred" formats={["AUTO", "WEBP", "AVIF"]} alt="Guarantee of Excellence" /></CardFigure>
      <CarDefaultBody className='card-body'>
        <CardTitle className="card-title">Guarantee of Excellence</CardTitle>
        <CardDesc>
          <p>Only Buildings and More can offer this amazing warranty.</p>
          <p>All Buildings and More buildings are engineered from top quality materials chosen for strength and durability. Each building is protected against termites, vermin, rain, and moisture.</p>
          <p>Buildings are warrantied for up to 36 months on materials and workmanship against defects, 20 years on treated.</p>
          <span>*Warranties may vary depending on manufacturer and geographical location.</span>
        </CardDesc>        
      </CarDefaultBody>
    </CarDefault>
  )
}

export default WarrantyCard;